<template>
  <div class="home">
    <div class="d-flex">
      <div class="item" @click="fetchModel" v-clipboard="copy">
        <span class="title">Tổng lượt truy cập web:</span>
        <span class="count">{{ modelData.view_txt }}</span>
      </div>
      <div class="item green" @click="updateSetting">
        <span class="title">Lượt mới</span>
        <span class="count d-flex align-items-center">
          <span>{{ modelData.view_old_txt }}</span>
          <i class="far fa-trash-alt"></i>
        </span>
      </div>
    </div>
    <el-row>
      <h2>Biểu đồ lượt truy cập</h2>
      <div class="model-filter">
        <el-col :span="8">
          <el-date-picker
            v-model="filter.date"
            @change="changeDateStatistic"
            type="daterange"
            value-format="yyyy-MM-dd"
            format="dd/MM/yyyy"
            range-separator="tới"
            start-placeholder="Ngày bắt đầu"
            end-placeholder="Ngày kết thúc"
            :picker-options="pickerOptions2">
          </el-date-picker>
        </el-col>
      </div>
      <div>
        <div id="statitic" v-loading="loading">
          <highcharts :options="chartOptions"></highcharts>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions } from 'vuex'
import {Chart} from 'highcharts-vue'
export default {
  name: 'HomeIndex',
  components: {
    highcharts: Chart
  },
  metaInfo () {
    return {
      title: 'Trang chủ'
    }
  },
  data () {
    return {
      loading: false,
      modelData: {

      },
      copy: 'Bên em chuyên nhận làm web/app ạ. Inbox em với ạ. https://ngalinh.com/',
      filter: {
        date: ''
      },
      chartOptions: {
        chart: {
          type: 'column'
        },
        title: {
          text: 'Biểu đồ thống kê tổng lượt truy cập'
        },
        subtitle: {
          text: 'Nguồn: ngalinh.com'
        },
        xAxis: {
          categories: [
          ],
          crosshair: true
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Số lượt'
          },
          labels: {
            overflow: 'justify'
          }
        },
        legend: {
          enabled: false
        },
        tooltip: {
          valueSuffix: ' lượt'
        },
        plotOptions: {
          column: {
            dataLabels: {
              enabled: true
            }
          }
        },
        credits: {
          enabled: true
        },
        series: [
          {
            name: 'Số lượt',
            data: []
          }
        ]
      },
      pickerOptions2: {
        shortcuts: [
          {
            text: 'Hôm nay',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 0)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '3 ngày trước',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 3)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '7 ngày trước',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '14 ngày trước',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 14)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Tháng này',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      }
    }
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchModel()
    this.initDateCurrent()
    this.fetchSatistic()
  },
  methods: {
    initDateCurrent () {
      let start = new Date()
      let ddstart = String(start.getDate()).padStart(2, '0')
      let mmstart = String(start.getMonth() + 1).padStart(2, '0')
      let yyyystart = start.getFullYear()
      let datestart = yyyystart + '-' + mmstart + '-' + ddstart

      var end = new Date()
      end.setDate(end.getDate() - 7)
      let ddend = String(end.getDate()).padStart(2, '0')
      let mmend = String(end.getMonth() + 1).padStart(2, '0')
      let yyyyend = end.getFullYear()
      let dateend = yyyyend + '-' + mmend + '-' + ddend

      this.filter.date = [dateend, datestart]
    },
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Tải dữ liệu Model xuống
    fetchModel () {
      this.canSubmit = false
      axios.get('settings/1').then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Tải lại cấu hình thành công',
              type: 'success',
              duration: 500
            })
            this.canSubmit = true
            this.modelData = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    updateSetting () {
      axios.put('settings/1', this.modelData).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Reset lượt mới thành công',
              type: 'success'
            })
            this.modelData.view_old_txt = 0
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    changeDateStatistic () {
      if (this.filter.date === null) {
        setTimeout(() => {
          this.initDateCurrent()
          this.fetchSatistic()
        }, 300)
      } else {
        this.fetchSatistic()
      }
    },
    fetchSatistic () {
      this.loading = true
      let filter = {
        'date': this.filter.date
      }
      axios.post('pings/statistic', filter).then(response => {
        this.loading = false
        switch (response.code) {
          case 200:
            this.chartOptions.xAxis.categories = response.data.categories
            this.chartOptions.series[0].data = response.data.series
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.home {
  margin-top: 15px;
}
.item {
  cursor: pointer;
  border-radius: 6px;
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 125px;
  width: 200px;
  background: rgb(0, 168, 255);
  margin-right: 15px;
}
.green {
  background: #27ae60
}
.title {
  font-size: 16px;
  color: #fff;
}
.count {
  font-size: 25px;
  color: #fff;
  margin-top: 5px
}
.count i {
  font-size: 14px;
  margin-left: 5px;
}
#statitic {
  background: #fff;
  min-height: 500px;
  padding-top: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/Index.vue